import { Card, Typography, Paper, Box, useTheme } from "@mui/material";


const WhyChooseItem = (props) => {

    const theme = useTheme();

    return (
        <Paper elevation={0} style={{background: 'transparent'}}>
            <Box 
            display={"inline-flex"}
            width={75}
            height={75}
            alignItems={"center"}
            justifyContent={"center"}
            border={"1px solid  rgb(0, 42, 115)"}
            // style={{background:'radial-gradient(circle, rgb(7, 129, 160) 0%, rgb(2, 66, 94) 87%, rgb(2, 66, 94) 100%, rgb(2, 66, 94) 100%)'}}
            borderRadius={1}
            mb={2}
            ><Typography variant="h4" color={theme.palette.primary.main} fontWeight={"normal"} >{props.no}</Typography></Box>
            <Typography variant="h6" fontWeight={"600"}>{props.title}</Typography>
        </Paper>
    )
}

export default WhyChooseItem;
